import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import 'react-table/react-table.css';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import {
  requestServiceRequests, deleteServiceRequest, requestServiceRequestStatuses,
  downloadServiceRequest
} from '../../../store/service-request-manager/ServiceRequestManagerActions';
import { requestClientsTypeahead } from '../../../store/client-manager/ClientManagerActions';
import LocationsFilterForm from '../../resource-library/components/LocationsFilterForm';
import Pagination from '../../../components/common/Pagination';
import Moment from '../../../components/utils/Moment';
import InfoBar from '../../../components/common/InfoBar';
import { hashHistory } from 'react-router';
import { hostTitle } from '../../../config/ui';
import { isExternalStakeholder, isSuperAdmin, isCareNavigator } from '../../../store/current-user/CurrentUserSelectors';
class ServiceRequestManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageSize: 25,
      page: 0,
      pages: -1,
      search: '',
      sorted: [],
      filtered: [],
      selectedOption: 0,
    };
    this.changeFilters = this.changeFilters.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentWillMount() {
    this.props.getRequestStatuses({
      tenantId: this.props.tenantId,
    });
  }

  searchClients = (search) => {
    return this.props
      .clientsTypeahead({
        tenantId: this.props.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  fetchData = (state) => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const statuses = (this.state.selectedOption > 0) ? [this.state.selectedOption] : [];
    const search = this.state.search;
    return this.props
      .getServiceRequests({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: filters,
        tenantId: this.props.tenantId,
        statuses: statuses,
        companies: this.state.location ? this.state.location.provider : [],
      })
      .then((response) =>
        this.setState({
          pages: response.payload
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  handleChange(event) {
    this.setState({ selectedOption: event.target.value }, () =>
      this.table.fireFetchData(),
    );
  }

  editServiceRequest = (id, mode) => {
    hashHistory.push(`/service-request-worklist/request/${id}/${mode}`);
  };

  addServiceRequest = (id, mode) => {
    hashHistory.push(`/service-request-worklist/request/${id}/${mode}`);
  };

  deleteServiceRequest = (id) => {
    this.props
      .deleteServiceRequest(id, {
        tenantId: this.props.tenantId,
      })
      .then(() => this.table.fireFetchData()
      );
  };

  changeFilters(params) {
    this.setState({ location: { ...this.location, ...params } }, () => this.fetchData(this.state));
  }
  
  downloadFile(state) {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const statuses = (this.state.selectedOption > 0) ? [this.state.selectedOption] : [];
    const search = this.state.search;
    this.props.downloadServiceRequest({
      offset: offset,
      limit: limit,
      order: order,
      search: search,
      filters: filters,
      tenantId: this.props.tenantId,
      statuses: statuses,
      companies: state.location ? state.location.provider : [],
    })
      .then((response) => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = "ServiceRequest";
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  render() {
    const { data, isExecutive, requestStatuses, isExternalStakeholder, isSuperAdmin, isCareNavigator } = this.props;

    var showDelete = (isSuperAdmin || isCareNavigator) ? true : false;

    var client = this.props.clients ? this.props.clients[0].name : '';
    return (
      <div id="content">
        <Helmet title={`Service Request Worklist – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Service Request Manager', 'Service Request Worklist']}
              icon="fa fa-fw fa-map"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>Service Request Worklist</h2>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <div
                      style={{ padding: 10, borderBottom: '1px solid #eeeeee' }}
                    >
                      <div className="row">
                        {isExternalStakeholder && (
                          <div className="col-md-3" >
                            <select
                              className="form-control"
                              name="status"
                              value={this.state.selectedOption}
                              onChange={this.handleChange}
                              disabled
                            >
                              <option value="0">{client}</option>
                            </select>
                          </div>
                        )}
                        {(isCareNavigator || isSuperAdmin) && (
                          <div className="col-md-3" >
                            <LocationsFilterForm searchLocations={this.searchClients} isMulti={true} onSubmit={this.changeFilters} />
                          </div>
                        )}
                        <div className="widget-toolbar">
                          <button disabled={isExecutive}
                            className="btn btn-primary btn-xs"
                            onClick={() => this.addServiceRequest('00000000-0000-0000-0000-000000000000', 'Add')}
                          >
                            Add Service Request
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{ padding: 10, borderBottom: '1px solid #eeeeee' }}
                    >
                      <div className="form-inline">
                        <div className="form-group">
                          <select
                            className="form-control"
                            name="status"
                            value={this.state.selectedOption}
                            onChange={this.handleChange}
                          >
                            <option value="0">Show All</option>
                            {requestStatuses &&
                              requestStatuses.map((el) => (
                                <option key={el.id} value={el.id}>
                                  {el.name}
                                </option>
                              ))}
                          </select>
                        </div>
                        &nbsp;&nbsp;
                        <button disabled={isExecutive}
                          className="btn btn-primary fa fa-download"
                          onClick={() => this.downloadFile(this.state)}
                        >
                        </button>
                      </div>
                    </div>
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.isLoading}
                      data={this.props.data ? this.props.data.list : []}
                      onFetchData={this.fetchData}
                      defaultSorted={[
                        {
                          id: 'code',
                          asc: true,
                        },
                      ]}
                      columns={[

                        {
                          Header: 'ID',
                          id: 'code',
                          accessor: 'code',
                          Cell: (row) => (
                            <a
                              onClick={() =>
                                this.editServiceRequest(
                                  row.original.id, 'Edit'
                                )
                              }
                            >
                              {row.original.code}
                            </a>
                          ),
                        },
                        {
                          Header: 'Name',
                          id: 'name',
                          filterable: true,
                          Cell: (row) => (
                            row.original.firstName + ' ' + row.original.lastName
                          ),
                        },
                        {
                          Header: 'Work Location',
                          id: 'workLocation',
                          filterable: true,
                          Cell: (row) => (
                            row.original.workLocation && row.original.workLocation.location
                          ),
                        },
                        {
                          Header: 'Service',
                          id: 'serviceType',
                          filterable: true,
                          Cell: (row) => (
                            row.original.serviceType && row.original.serviceType.name
                          ),
                        },
                        {
                          Header: 'Service Location',
                          id: 'serviceLocation',
                          Cell: (row) => (
                            row.original.serviceLocation && row.original.serviceLocation.serviceProvider
                          ),
                        },
                        {
                          Header: 'Target Date',
                          id: 'requestedCompletion',
                          accessor: 'requestedCompletion',
                          filterable: true,
                          Cell: (row) => ((row.original.requestedCompletion == null) ? '' :
                            <Moment
                              date={row.original.requestedCompletion}
                              format="MM/DD/YYYY"
                            />
                          ),
                        },
                        {
                          Header: 'Appt Date',
                          id: 'appointmentDate',
                          width: 140,
                          Cell: (row) => (
                            (row.original.appointments) &&
                            <Moment
                              date={row.original.appointments.appointmentAt}
                              format="MM/DD/YYYY hh:mm A"
                            />
                          ),
                        },
                        {
                          Header: 'Status',
                          id: 'status',
                          Cell: (row) => (
                            row.original.requestStatus && row.original.requestStatus.name
                          ),
                        },
                        {
                          Header: 'Completed Date',
                          id: 'completionDate',
                          Cell: (row) => ((row.original.completionDate == null) ? '' :
                            <Moment
                              date={row.original.completionDate}
                              format="MM/DD/YYYY"
                            />
                          ),
                        },
                        {
                          Header: 'Next Due',
                          id: 'nextDueDate',
                          Cell: (row) => ((row.original.nextDueDate == null) ? '' :
                            <Moment
                              date={row.original.nextDueDate}
                              format="MM/DD/YYYY"
                            />
                          ),
                        }, 
                        {
                          Header: 'Outcome',
                          id: 'outcome',
                          Cell: (row) => (
                            row.original.outcomeStatus && row.original.outcomeStatus.name
                          ),
                        },
                        {
                          Header: 'Documents',
                          id: 'files',
                          width: 100,
                          sortable: false,
                          Cell: (row) => (
                            (row.original.files.length > 0) ?
                             <a
                              onClick={() =>
                                this.editServiceRequest(
                                  row.original.id
                                )
                              }
                            >
                              View
                            </a>
                            : <span> </span>
                          ),
                        },
                        {
                          Header: '',
                          id: 'actions',
                          width: 50,
                          sortable: false,
                          show: showDelete,
                          Cell: (row) => (
                            <span>
                              <button 
                                className="btn btn-default btn-xs"
                                onClick={() => this.deleteServiceRequest(row.original.id)}>
                                <i className="fa fa-trash" />
                              </button>
                            </span>
                          ),
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      //filterable
                      className="-striped -highlight"
                      showPaginationTop={false}
                      PaginationComponent={Pagination}
                      //onSearchChange={this.handleSearch}
                    />
                   
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.servicerequestmanager,
    tenantId: state.currentUser.queryParams.tenantId,
    clients: state.currentUser.data.clients,
    isExternalStakeholder: isExternalStakeholder(state),
    isSuperAdmin: isSuperAdmin(state),
    isCareNavigator: isCareNavigator(state),
  }),
  (dispatch) => ({
    getServiceRequests: (params) => dispatch(requestServiceRequests(params)),
    clientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    deleteServiceRequest: (id, params) => dispatch(deleteServiceRequest(id, params)),
    getRequestStatuses: (params) => dispatch(requestServiceRequestStatuses(params)),
    downloadServiceRequest: (params) => dispatch(downloadServiceRequest(params)),
  }),
)(ServiceRequestManager);



// WEBPACK FOOTER //
// ./src/routes/service-request-manager/containers/ServiceRequestManager.js